import { Table } from 'react-dsgov';
import styles from './receitaExportacoesDetalhes.module.scss';
import { formatCurrency } from '../../../../../../../../../../utils/formatCurrency';
import {
  IOperacaoReceitaExportacoesResumo,
  IOperacaoReceitaExportacoesResumoItem,
  IOutrosRegimesTributo,
} from '../../../../../../../../../../interfaces/IOperacoes';

interface IHeader {
  field: string;
  label: string;
  format?: Function;
  value?: string | Function;
}

interface IFooter {
  value: string | JSX.Element | JSX.Element[];
  colspan?: number;
  show?: boolean;
}

interface IProps {
  data: IOperacaoReceitaExportacoesResumo;
}

function ReceitaExportacoesDetalhes({ data }: IProps) {
  const TABELA_CABECALHO: IHeader[] = [
    {
      field: 'codigoNcm',
      label: 'Código NCM',
    },
    {
      field: 'valorReceitaBrutaCalculada',
      label: 'Receita Calculada (R$)',
      format: formatCurrency,
    },

    {
      field: 'quantidade',
      label: 'Quantidade',
      format: formataQuantidade,
    },
    {
      field: 'unidadeMedida',
      label: 'Unidade de Medida',
    },
    { field: 'valorPrecoMedio', label: 'Preço Médio (R$)', value: formatarPrecoMedio },
    { field: 'tributosValores', label: 'Deduções(R$)' },
    { field: 'valorBaseCalculo', label: 'Base de Cálculo (R$)', format: formatCurrency },
    {
      field: 'isRejeito',
      label: 'Rejeitos/Estéreis',
      format: formataBoolean,
    },
    {
      field: 'hasUsoEspecifico',
      label: 'Uso Específico',
      format: formataBoolean,
    },
  ];

  const TABELA_RODAPE: IFooter[] = [
    { value: <span>Total (R$)</span> },
    { value: formatCurrency(data.valorTotalOperacao) },
    { value: formataQuantidade(data.quantidadeTotal) },
    { value: '', colspan: 2 },
    { value: colunaDeducoes(data.valorTotalTributosValores, data.valorTotalDeducoes, data.valorTotalTerceiro) },
    { value: formatCurrency(data.valorTotalBaseCalculo) },
    { value: '', colspan: 2 },
  ];

  function formataBoolean(valor: boolean) {
    return valor ? 'Sim' : 'Não';
  }

  function formataQuantidade(valor: number) {
    return valor.toLocaleString('pt-br');
  }

  function formatarPrecoMedio(item: IOperacaoReceitaExportacoesResumoItem) {
    return (
      <div>
        <span>{formatCurrency(item.valorPrecoMedio)}</span>
      </div>
    );
  }

  function colunaDeducoes(tributos: IOutrosRegimesTributo[], valorTotalDeducoes: number, valorTotalTerceiros: number) {
    let content: JSX.Element[] = [];

    if (tributos && tributos.length > 0) {
      tributos.forEach((item: IOutrosRegimesTributo) => {
        content.push(
          <div className={styles.deducoes} key={item.id}>
            <span>{item.nome}:</span> {formatCurrency(item.valor)}
          </div>
        );
      });
    }
    content.push(
      <>
        <div className={styles.deducoes} key={'divValorComprasterceiro'}>
          <span>Compras de Terceiro:</span> {formatCurrency(valorTotalTerceiros)}
        </div>
        <div className={styles.deducoes} key={'divValorTotalTributos'}>
          <span>Total:</span> {formatCurrency(valorTotalDeducoes)}
        </div>
      </>
    );

    return content;
  }

  return (
    <div className={styles.secao}>
      <div className={styles.tabela}>
        <Table
          showTopBar={false}
          headers={TABELA_CABECALHO}
          showPagination={false}
          showDensityButtons={false}
          showSearch={false}
          density='medium'
          tabIndex={0}
        >
          <tbody>
            {data?.listaNcm && data.listaNcm.length > 0 ? (
              data.listaNcm.map((item: any) => (
                <tr key={item.codigoNCM} data-testid='linha-dados'>
                  {TABELA_CABECALHO.map((header) => (
                    <td key={header.field} className={styles.tableCell}>
                      {header.format
                        ? header.format(item[header.field as keyof IOperacaoReceitaExportacoesResumo])
                        : header.field === 'tributosValores'
                          ? colunaDeducoes(
                              item[header.field as keyof IOperacaoReceitaExportacoesResumo] as IOutrosRegimesTributo[],
                              item.valorDeducoes ?? 0,
                              item.valorAquisicaoTerceiros ?? 0
                            )
                          : (item[header.field as keyof IOperacaoReceitaExportacoesResumo] ?? '')}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr data-testid='sem-operacao'>
                <th className={`border-right`} rowSpan={1} scope='rowgroup'></th>
                <td colSpan={5} className={styles.noOperacoes}>
                  Não há operações cadastradas
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr data-testid='linha-rodape'>
              {TABELA_RODAPE.map((footer, index) => (
                <td key={index} colSpan={footer.colspan ?? 1}>
                  {footer.show ?? footer.value}
                </td>
              ))}
            </tr>
          </tfoot>
        </Table>
      </div>
    </div>
  );
}

export default ReceitaExportacoesDetalhes;
